/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import { PageHeader, Section } from '../../shared/components';
import LastNotifications from '../Notifications/LastNotifications';
import TaskPanel from './TaskPanel';
import OverviewPanel from './Overview/OverviewPanel';
import useQuery from '../../shared/hooks/useQuery';

// For now, Dashboard redirects to Operations
const Dashboard: React.FC = () => {
  const { t } = useTranslation();
  const myRef = useRef<HTMLDivElement>(null);

  const scrollToGantt = () => {
    if (myRef.current) {
      window.scrollTo({ behavior: 'smooth', top: myRef.current.offsetTop });
    }
  };
  return (
    <Container className="dashboard">
      <PageHeader title={t('currentTasks')} noBack />
      <Row>
        <OverviewPanel scrollToGantt={scrollToGantt} />
      </Row>
      <div ref={myRef} />
      <Row>
        <TaskPanel />
      </Row>
      <Row>
        <Section title="My Missions" md={9} />
        <Section title="My Notifications" md={3}>
          <LastNotifications />
        </Section>
      </Row>
    </Container>
  );
};

export default Dashboard;
